<template>
  <section
    :class="{
      'section-login': true,
      'light-mode': $route.query.type === 'walmart'
    }"
  >
    <div class="container">
      <div class="section-login-inner">
        <form @submit.prevent="register">
          <b-img
            class="trebel-logo"
            :src="`${publicPath}assets/images/trebel-yellow.png`"
            :alt="$t('TREBEL')"
          ></b-img>
          <h3 class="login-title">
            {{
              $route.query.type === "walmart"
                ? $t("createAccount")
                : $t("welcomeBack")
            }}
          </h3>
          <div v-if="error.message" class="invalid-field mb-3">
            {{ error.message }}
          </div>

          <div class="form-control-icon-wrap">
            <b-img
              :src="`${publicPath}assets/images/icons/icon-mail.svg`"
              alt
            ></b-img>

            <b-form-input
              :class="{
                'form-control-walmart': $route.query.type === 'walmart',
                'error-borders':
                  formErrors.findIndex(item => item.field === 'email') !== -1
              }"
              type="email"
              v-model="credentials.email"
              placeholder="Email"
              v-validate="'required|email'"
              name="email"
              data-vv-as="Email"
              data-vv-validate-on="blur"
              autocapitalize="off"
            ></b-form-input>
            <div v-if="errors.has('email')" class="invalid-field">
              {{ errors.first("email") }}
            </div>
          </div>
          <div class="form-control-icon-wrap">
            <b-img
              :src="`${publicPath}assets/images/icons/icon-lock.svg`"
              alt
            ></b-img>
            <b-form-input
              :class="{
                'form-control-walmart': $route.query.type === 'walmart',
                'error-borders':
                  formErrors.findIndex(item => item.field === 'password') !== -1
              }"
              type="password"
              v-model="credentials.password"
              :placeholder="$t('password')"
              v-validate="'required|min:6'"
              name="password"
              initial="off"
              data-vv-validate-on="blur"
              :data-vv-as="$t('password')"
            ></b-form-input>
            <div v-if="errors.has('password')" class="invalid-field">
              {{ errors.first("password") }}
            </div>
          </div>
          <p
            :class="{
              'login-forgot-password': true,
              'login-forgot-password-dark': $route.query.type === 'walmart'
            }"
          >
            {{ $t("choosePassword") }}
          </p>
          <b-button type="submit" :variant="btnClass" block class="btn-login">{{
            $t("createAccount")
          }}</b-button>
          <div
            v-if="$route.query.type === 'walmart'"
            class="login__for-walmart"
          >
            {{ $t("haveAccount") }} <br /><b
              ><b-link
                :to="{
                  name: 'Login',
                  query: {
                    redirectTo: this.$route.query.redirectTo,
                    type: this.$route.query.type
                  }
                }"
                >{{ $t("logIn") }}</b-link
              ></b
            >
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { authComputed } from "@/store/helpers.js";
import helpers from "../helpers";
export default {
  data() {
    return {
      credentials: {
        email: "",
        password: "",
        rememberIsChecked: true
      },
      error: {
        message: ""
      },
      validate: false,
      formErrors: []
    };
  },
  computed: {
    ...authComputed,
    isDisabled() {
      return this.credentials.password.length < 6 || !this.credentials.email;
    },
    btnClass() {
      if (this.$route.query.type === "walmart") {
        return this.isDisabled ? "light" : "dark";
      } else {
        return this.isDisabled ? "#000000" : "#ffffff";
      }
    }
  },
  methods: {
    register() {
      this.validate = true;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.$store
          .dispatch("register", this.credentials)
          .then(async res => {
            // TMP solution
            // if (this.$route.query.type === "walmart") {
            //   window.location.href = `${
            //     this.$route.query.redirectTo
            //   }&user=${btoa(localStorage.getItem("user"))}`;
            // } else {
            const newUser = res && res.user ? res.user : undefined;
            helpers
              .fireClevertapEvent({
                event: "registration_completed",
                body: {
                  source: "landing",
                  mode: this.mode,
                  method: "email"
                },
                newUserId: newUser.userId,
                oldUserId:
                  this.$route.query && this.$route.query.identity
                    ? this.$route.query.identity
                    : undefined
              })
              .then(() => {
                window.location.href = this.$route.query.redirectTo
                  ? this.$route.query.redirectTo
                  : process.env.VUE_APP_REDIRECT;
              });

            // }
          })
          .catch(error => {
            this.error.message = error?.response?.data?.error?.message;
          });
      });
    }
  }
};
</script>
